import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import ChallengeMe from './ChallengeMe'
import { getUserGoal } from '../Activity/store/ActivitySelectors'
import { cancelGetChallengesWithProgress, getSingleChallengeWithProgress } from '../Activity/store/ActivityActions'
import { resetManualEntryInProgress } from '../Progress/store/ProgressActions'

const mapStateToProps = (state: IGlobalState, ownProps: any) => ({
  goalId: ownProps.match.params.goalId,
  goal: getUserGoal(state, ownProps.match.params.goalId),
})

const mapDispatchToProps = {
  getSingleChallengeWithProgress,
  cancelGetChallengesWithProgress,
  resetManualEntryInProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeMe)
